import createFetchWebEventCollector from './FetchWebEventCollector'

export { createFetchWebEventCollector }
